<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <edit-profile-form>
          </edit-profile-form>
          <div>
            <div style="padding: 0!important;" class="container-fluid">
              <card>
                <div class="col-12">
                  <div class="row">
                    <div class="col">
                      <h4 class="card-title">Lista de Usuarios</h4>
                    </div>
                    <div class="col" style="padding-right: 15px;">
                      <button style="border: none; background-color: #0d6efd;" class="btn btn-info btn-fill float-right"
                        @click.prevent="openNewUserPopup()">
                        Crear Usuario
                      </button>
                    </div>
                  </div>
                </div>
                <table class="table">
                  <thead>
                    <tr>
                      <th>NOMBRE</th>
                      <th>EMAIL</th>
                      <th>ROL</th>
                      <th>ESTADO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in users" :key="index">
                      <td>{{ item.name }}</td>
                      <td>{{ item.email }}</td>
                      <td v-if="item.rol == 1">Administrador</td>
                      <td v-else>Operador</td>
                      <td v-if="item.status == 1">Activo</td>
                      <td v-else>Inactivo</td>
                      <td>
                        <button type="button" class="navbar-toggler navbar-toggler-right"
                          aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation"
                          @click="openEditPopup(item)">
                          <i style="color: #0d6efd;" class="nc-icon nc-settings-gear-64"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </card>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vs-popup classContent="popup-example" title="Editar Usuario" :active.sync="popUpEditUser">
      <div class="row">
        <div class="col-xl-4 col-md-4"><vs-input label="Nombre" class="inputx" placeholder="Nombre"
            v-model="form.name" /></div>
        <div class="col-xl-4 col-md-4"><vs-input label="Email" class="inputx" placeholder="Email"
            v-model="form.email" /></div>
        <div class="col-xl-4 col-md-4"><vs-select class="inputx" label="Rol" v-model="form.rol">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options" />
          </vs-select></div>
        <div class="col-xl-4 col-md-4"><vs-select multiple required class="inputx" label="Vehículos"
            v-model="form.vehicles">
            <vs-select-item :key="index" :value="item.placa" :text="item.placa" v-for="item, index in listVehicles" />
          </vs-select></div>
        <div class="col-xl-4 col-md-4"><vs-select required class="inputx" label="Reportes" v-model="form.report">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options1" />
          </vs-select></div>
        <div class="col-xl-4 col-md-4"><vs-select class="inputx" label="Estado" v-model="form.status">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options1" />
          </vs-select></div>
        <div class="col-xl-4 col-md-4"><vs-input label="Password" class="inputx" placeholder="Password"
            v-model="form.password" /></div>
        <div style="align-self: flex-end;" class="col-xl-4 col-md-4">
          <vs-button @click="editUser()" color="primary" type="filled">Editar</vs-button>
        </div>
      </div>
    </vs-popup>
    <vs-popup classContent="popup-example" title="Crear Usuario" :active.sync="popUpNewUser">
      <div class="row">
        <div class="col-xl-4 col-md-4"><vs-input required label="Nombre" class="inputx" placeholder="Nombre"
            v-model="formNew.name" /></div>
        <div class="col-xl-4 col-md-4"><vs-input required label="Email" class="inputx" placeholder="Email"
            v-model="formNew.email" /></div>
        <div class="col-xl-4 col-md-4"><vs-select required class="inputx" label="Rol" v-model="formNew.rol">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options" />
          </vs-select></div>
        <div class="col-xl-4 col-md-4"><vs-select multiple required class="inputx" label="Vehículos"
            v-model="formNew.vehicles">
            <vs-select-item :key="index" :value="item.id_vehicle" :text="item.placa"
              v-for="item, index in listVehicles" />
          </vs-select></div>
        <div class="col-xl-4 col-md-4"><vs-select required class="inputx" label="Reportes" v-model="formNew.report">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options1" />
          </vs-select></div>
        <div class="col-xl-4 col-md-4"><vs-select required class="inputx" label="Estado" v-model="formNew.status">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item, index in options1" />
          </vs-select></div>
        <div class="col-xl-4 col-md-4"><vs-input required label="Password" class="inputx" placeholder="Password"
            v-model="formNew.password" /></div>
        <div style="align-self: flex-end;" class="col-xl-4 col-md-4">
          <vs-button v-bind:disabled="isDisabled" @click="newUser()" color="primary" type="filled">Crear</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import EditProfileForm from './UserProfile/EditProfileForm.vue'
import UserCard from './UserProfile/UserCard.vue'
import Card from 'src/components/Cards/Card.vue'
import getSecret from '../helpers/get-secret';
const serverUrl = getSecret('SERVER_URL');


export default {
  components: {
    EditProfileForm,
    UserCard,
    Card
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
      name_company: JSON.parse(localStorage.getItem('jwt_licencia')).name,
      users: '',
      popUpEditUser: false,
      popUpNewUser: false,
      isDisabled: false,
      form: {
        name: '',
        email: '',
        rol: '',
        status: '',
        password: '',
        id: '',
        vehicles: [],
        report: false,
      },
      formNew: {
        name: '',
        email: '',
        rol: '',
        status: '',
        password: '',
        id_company: JSON.parse(localStorage.getItem('jwt_licencia')).id_company,
        vehicles: [],
        report: false,
      },
      options: [
        { text: 'Administrador', value: 1 },
        { text: 'Operador', value: 2 },
      ],
      options1: [
        { text: 'Activo', value: true },
        { text: 'Inactivo', value: false },
      ],
      listVehicles: []
    }
  },
  methods: {
    getListUsers() {
      this.axios.get(serverUrl + '/api/getListUsers/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.users = res.data.users;
            console.log(this.users)
          } else {
            console.log(res.data);
          }
        })
        .catch(err => {
          console.log(err.data);
        });
    },
    openEditPopup(item) {
      this.popUpEditUser = true;
      this.form.name = item.name;
      this.form.email = item.email;
      this.form.rol = item.rol;
      this.form.status = item.status;
      this.form.id = item.id;
      this.form.vehicles = item.vehicles;
      this.form.report = item.report;
    },
    openNewUserPopup() {
      this.popUpNewUser = true;
      this.formNew.status = true;
    },
    editUser() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.axios.post(serverUrl + '/api/editUser', this.form)
        .then(res => {
          if (res.data.status == 200) {
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Usuario Actualizado.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            });
            this.getListUsers();
            this.$vs.loading.close();
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar el Usuario.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
          this.popUpEditUser = false;
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar el Usuario.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
          this.popUpEditUser = false;
        });
    },
    getListVehicles() {
      this.axios.get(serverUrl + '/api/getListVehicle/' + this.id_company)
        .then(res => {
          if (res.data.status == 200) {
            this.listVehicles = res.data.vehicles;
          } else {
            console.log('Error getListVehicle');
          }
        })
        .catch(err => {
          console.log('Error getListVehicle');
        });
    },
    newUser() {
      this.$vs.loading({
        type: 'radius',
        color: 'primary'
      })
      this.isDisabled = true;
      this.axios.post(serverUrl + '/api/newUser', this.formNew)
        .then(res => {
          if (res.data.status == 200) {
            this.$notifications.notify({
              message: `<span><b>¡Éxito!</b><br>Usuario Creado con Éxito.</span>`,
              icon: 'nc-icon nc-send',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'info'
            });
            this.getListUsers();
            this.$vs.loading.close();
            this.formNew.name = null;
            this.formNew.email = null;
            this.formNew.rol = null;
            this.formNew.status = true;
            this.formNew.password = null;
            this.formNew.vehicles = [];
            this.formNew.report = false;
          } else {
            this.$notifications.notify({
              message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar el Usuario.</span>`,
              icon: 'nc-icon nc-support-17',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'danger'
            })
            this.$vs.loading.close();
          }
          this.popUpNewUser = false;
        })
        .catch(err => {
          this.$notifications.notify({
            message: `<span><b>¡Error!</b><br>Ocurrió un error al actualizar el Usuario.</span>`,
            icon: 'nc-icon nc-support-17',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'danger'
          })
          this.$vs.loading.close();
          this.popUpNewUser = false;
        });
      this.isDisabled = false;
    },
  },
  mounted() {
    this.getListUsers();
    this.getListVehicles();
  }
}

</script>
<style>
.con-select {
  width: 100%;
}
</style>
